import React, { type ReactNode } from 'react'
import { ChatClientProviderV2 } from './ChatClientProviderV2'
import { ChatUnreadProviderV2 } from './ChatUnreadProviderV2'
import { ChatChannelListProviderV2 } from './ChatChannelListProviderV2'
import { ChatActiveChannelProviderV2 } from './ChatActiveChannelProviderV2'

export const ChatV2Provider: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <ChatClientProviderV2>
    <ChatUnreadProviderV2>
      <ChatChannelListProviderV2>
        <ChatActiveChannelProviderV2>{children}</ChatActiveChannelProviderV2>
      </ChatChannelListProviderV2>
    </ChatUnreadProviderV2>
  </ChatClientProviderV2>
)
